



















































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./add.vue";
import Edit from "./edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  dispatchType: string = "bom/materialList";

  dispatchTypeDelete: string = "bom/deleteMaterial";

  deleteConfirmTitle: string = "你确定要删除该物料吗？";

  categories: any[] = [];

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "物料名称", dataIndex: "name" },
    { title: "分类", dataIndex: "category_name" },
    { title: "规格", dataIndex: "spec" },
    { title: "单位", dataIndex: "unit" },
    { title: "价格", scopedSlots: { customRender: "price" } },
    { title: "每增加片场数的价格", scopedSlots: { customRender: "ext_price" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();

    this.loadCategories();
  }

  async loadCategories() {
    const res = await this.$store.dispatch("bom/categories", {});
    if (res && res.Data) {
      this.categories = res.Data;
    }
  }
}
